import { Field, FieldArray, ErrorMessage } from "formik";
import { Autocomplete, TextField } from "@mui/material";

interface DocumentProps {
  values: any;
  setAddDocumentModalStatus: (show: boolean) => void;
  documentList: any[];
  documentSuggestionList: any[];
  setFieldValue: any;
  permissions: any;
}

const DocumentFields: React.FC<DocumentProps> = ({
  values,
  documentList,
  setAddDocumentModalStatus,
  documentSuggestionList,
  setFieldValue,
  permissions,
}) => {
  return (
    <div className="card my-card">
      <FieldArray
        name="document"
        render={({ push, remove }) => (
          <>
            <div className="card-header my-card-header bg-lighter d-flex justify-content-between">
              <div>
                <h6 className="my-card-header-head">Documents</h6>
              </div>
              <div>
                <button
                  title="Add Document"
                  className="btn btn-sm btn-primary waves-effect waves-light p-0"
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => {
                    push({
                      document_id: "",
                      value: "",
                    });
                  }}
                >
                  <span>
                    <i className="ti ti-plus my-card-icon-button"></i>
                  </span>
                </button>
              </div>
            </div>
            {values.document.map((_: any, index: number) => (
              <div
                className="card-body my-card-body"
                style={{ paddingBottom: 0, paddingTop: 0 }}
              >
                <div className="sales_section_card" key={index}>
                  <div className="row g-3 m-0">
                    <div className="col-12 col-sm-6 col-md-4">
                      <div className="d-flex justify-content-between">
                        <div>
                          <label
                            htmlFor={`document[${index}].document_id`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Document: <span className="text-danger">*</span>
                          </label>
                        </div>
                        {permissions.includes("create-document") && (
                          <div>
                            <button
                              title="Add Document"
                              className="btn btn-sm btn-primary waves-effect waves-light p-0"
                              type="button"
                              onClick={() => setAddDocumentModalStatus(true)}
                            >
                              <span>
                                <i className="ti ti-plus my-card-icon-button"></i>
                              </span>
                            </button>
                          </div>
                        )}
                      </div>

                      <Field
                        as="select"
                        name={`document[${index}].document_id`}
                        className="form-select"
                      >
                        <option value="">Select Document</option>
                        {documentList.map((data) => {
                          const isOptionDisabled = values.document.some(
                            (doc: any, docIndex: number) =>
                              doc.document_id === data.id && docIndex !== index
                          );

                          return (
                            <option
                              key={data.id}
                              value={data.id}
                              disabled={isOptionDisabled}
                            >
                              {data.name}
                            </option>
                          );
                        })}
                      </Field>
                      <ErrorMessage
                        name={`document[${index}].document_id`}
                        component="div"
                        className="text-danger"
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-8">
                      <label
                        htmlFor={`document[${index}].value`}
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        No Of Copies: <span className="text-danger">*</span>
                      </label>
                      <Autocomplete
                        disablePortal
                        options={
                          documentSuggestionList[
                            values.document[index].document_id
                          ] || []
                        }
                        value={values?.document[index]?.value}
                        onChange={(event, newValue) => {
                          setFieldValue(`document[${index}].value`, newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="form-control"
                            type="text"
                            placeholder="Enter Quality Specification Value"
                            onChange={(e) =>
                              setFieldValue(
                                `document[${index}].value`,
                                e.target.value
                              )
                            }
                          />
                        )}
                      />
                      <ErrorMessage
                        name={`document[${index}].value`}
                        component="div"
                        className="text-danger"
                      />
                    </div>
                    <i
                      className="fa-solid fa-xmark sales_document_btn"
                      onClick={() => remove(index)}
                    ></i>
                  </div>
                </div>
              </div>
            ))}
            {values.document?.length > 0 && (
              <div className="row m-2 justify-content-end">
                <button
                  title="Add Document"
                  type="button"
                  className="btn btn-primary col-12 col-sm-auto"
                  onClick={() => {
                    push({
                      document_id: "",
                      value: "",
                    });
                  }}
                >
                  Add Document
                </button>
              </div>
            )}
          </>
        )}
      />
    </div>
  );
};

export default DocumentFields;
